import './LoginForm.css';

import Error from 'components/alerts/Error';
import { openModal } from 'components/modal/modules/dispatcher/methods';
import { DataValidator } from 'components/validation/data/DataValidator';
import cloneDeep from 'lodash/cloneDeep';
import ForgotPasswordForm from 'pages/auth/login/components/login-form/ForgotPassword';
import * as React from 'react';

import { Card, Label } from 'reactstrap';

// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withCookies } from 'react-cookie';
// import FacebookLogin from 'react-facebook-login';
// import { GoogleLogin } from 'react-google-login';
import { connect } from 'react-redux';
// import { Redirect } from 'react-router';
import { ClipLoader } from 'react-spinners';
import { AuthenticationService } from 'services/api/Authentication.service';
import UserDucks from 'stores/ducks/User.duck';
import * as yup from 'yup';
import Signup from './Signup';


interface ILoginFormState {
  password: {
    username: string;
    password: string;
  };
  facebook: {
    name?: string | null;
    accessToken?: string | null;
    clicked: boolean;
  };
  isValid: boolean;
  error: boolean;
  changePassword: boolean;
}

interface IProps {
  isLoggedIn?: boolean;
  isLoading?: boolean;
  dispatch?: any;
  cookies?: any;
}

/**
 * The form that is used for login. Also handles the forgot password functionality.
 */
class LoginForm extends React.Component<IProps, ILoginFormState> {

  public state: ILoginFormState = {
    password: {
      username: "",
      password: ""
    },
    facebook: {
      name: null,
      accessToken: null,
      clicked: false
    },
    isValid: true,
    error: false,
    changePassword: false
  };

  private AuthService = new AuthenticationService();

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFacebookCallback = this.handleFacebookCallback.bind(this);
    this.handleGoogleCallback = this.handleGoogleCallback.bind(this);
    this.handleFacebookContinueAsClick = this.handleFacebookContinueAsClick.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.setLoading = this.setLoading.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.openSignUpModal = this.openSignUpModal.bind(this);
  }

  public componentWillUnmount() {
    this.setLoading(false);
  }

  public handleChangeInput(e: any) {
    const { state } = this;
    const { password } = this.state;
    this.setState({
      ...state,
      password: {
        ...password,
        [e.target.name]: e.target.value
      }
    });
  }

  public handleSuccess() {
    return true;
  }

  public handleError() {
    return false;
  }

  public openSignUpModal() {
    const content = <Signup />
    openModal(content, 'Sign Up', [])
  }

  public handleSubmit(e: any) {
    e.preventDefault();
    const { username, password } = this.state.password;
    this.setLoading(true);
    this.AuthService.authWithPassword(username.toLowerCase(), password)
      .catch(ee => {
        this.setLoading(false);
        this.setState({ ...this.state, error: true })
        return ee;
      })
      .then((res: any) => {

        if (res.token === undefined) {
          this.setLoading(false);
          this.setState({ ...this.state, error: true })
          return false;
        }

        const newRes = cloneDeep(res);
        delete newRes.events;
        // Removing old cookies
        this.props.cookies.remove("user", { path: "/" });
        this.props.cookies.remove("token", { path: "/" });
        // Putting new cookies
        const date = new Date(); date.setDate(date.getDate() + 7);
        this.props.cookies.set("user", newRes, { path: "/", expires: date });
        this.props.cookies.set("token", res.token, { path: "/", expires: date });
        this.props.dispatch(UserDucks.setUser(res));
        window.location.pathname = '/campaigns'
        return true;

      });
    return null;
  }

  public forgotPassword() {
    this.setState({ changePassword: true })
  }

  public async handleFacebookCallback(res) {
    const responseJson = await this.AuthService.authWithFaceboook(
      res.accessToken
    );
    if (this.state.facebook.clicked === true) {
      const newRes = cloneDeep(responseJson);
      delete newRes.events;
      this.props.dispatch(UserDucks.setUser(responseJson));
      // Removing old cookies
      this.props.cookies.remove("user", { path: "/" });
      this.props.cookies.remove("token", { path: "/" });
      // Putting new cookies
      const date = new Date(); date.setDate(date.getDate() + 7);
      this.props.cookies.set("user", newRes, { path: "/", expires: date });
      this.props.cookies.set("token", newRes.token, { path: "/", expires: date });
    } else {
      if (responseJson.fullname) {
        this.setState({
          facebook: {
            clicked: false,
            name: responseJson.fullname,
            accessToken: res.accessToken || null
          }
        });
      }
    }
  }

  public async handleFacebookContinueAsClick(e: any) {
    e.preventDefault();
    const facebook = {
      name: this.state.facebook.name,
      accessToken: this.state.facebook.accessToken,
      clicked: true
    };
    this.setState(
      { facebook },
      () => {
        this.handleFacebookCallback({
          accessToken: this.state.facebook.accessToken
        });
      }
    );
  }

  public async handleGoogleCallback(res) {
    // console.log(res)
    // console.log(res.accessToken)
    const accessToken = res.accessToken;
    const responseJson = await this.AuthService.authWithGoogle(accessToken);
    const newRes = cloneDeep(responseJson);
    delete newRes.events;
    this.props.dispatch(UserDucks.setUser(responseJson));
    // Removing old cookies
    this.props.cookies.remove("user", { path: "/" });
    this.props.cookies.remove("token", { path: "/" });
    // Putting new cookies
    const date = new Date(); date.setDate(date.getDate() + 7);
    this.props.cookies.set("user", newRes, { path: "/", expires: date });
    this.props.cookies.set("token", newRes.token, { path: "/", expires: date });
  }

  public renderGoogleButton(props) {
    return (
      <button
        role="facebook"
        className="btn-google"
        onClick={props.onClick}
        style={{ border: 'none' }}
      >
        Login with Google
      </button>
    );
  }

  public render() {

    const error = this.state.error === true
      ?
      <div>
        <br />
        <Error content={"Invalid Login Credentials"} />
      </div>
      : null

    if (this.props.isLoggedIn) {
      window.location.pathname = '/campaigns'
    }

    const login = (
      <DataValidator
        rules={{
          email: yup
            .string()
            .required()
            .email(),
          password: yup
            .string()
            .required()
            .min(8)
        }}
        data={{
          email: this.state.password.username,
          password: this.state.password.password
        }}
        isValid={valid => this.setState({ isValid: valid })}
      >
        <div style={{ width: '100%' }}>
          <form
            onSubmit={this.handleSubmit}
            style={{ width: '100%' }}
          >
            <React.Fragment>
              <p>
                <br />
              </p>
              <div style={{ width: '100%' }}>
                <Label style={{ width: '100%' }}>
                  E-mail or Username
              </Label>
                <div>
                  <input
                    name="username"
                    value={this.state.password.username}
                    onChange={this.handleChangeInput}
                    required={true}
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <p />
              <div style={{ width: '100%' }}>
                <Label style={{ width: '100%' }}>
                  Password
                </Label>
                <div>
                  <input
                    type="password"
                    name="password"
                    value={this.state.password.password}
                    onChange={this.handleChangeInput}
                    required={true}
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <br />
              <br />
              <div className="login-button-div">
                <button
                  role="submit"
                  type="submit"
                  className="new-button-blue-gradient"
                >
                  {/* &nbsp; to increase spacing */}
                  &nbsp;LOGIN&nbsp;
                    </button>
                {error}
              </div>
            </React.Fragment>
          </form>
          {
            this.props.isLoading ? null :
              <div style={{ width: '100%', textAlign: 'center' }}>
                <p />
                <button
                  className="new-button-blue-outline"
                  onClick={() => this.openSignUpModal()}
                >
                  SIGN UP
            </button>
                <p />
                <button className="button_link" onClick={this.forgotPassword}>Forgot Password?</button>
                <p />
              </div>
          }
        </div>
      </DataValidator>
    )

    return (
      <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
        {this.props.isLoading ? (
          <div className="p-4 w-100 text-center">
            <ClipLoader color={"#000000"} loading={true} />
          </div>
        ) : (
          <div style={{
            justifyContent: 'center',
            paddingTop: '50px',
            width: '100%', display: 'flex'
          }}>
            <Card style={{ padding: '20px', width: screen.width >= 768 ? '400px' : '100%' }}>
              {
                this.props.isLoading ? null :
                  <div style={{ width: '100%', textAlign: 'center' }}>
                    <p style={{ width: '100%' }} />
                    <img src={require('./Dark-logo.png')} style={{ width: '120px' }} />
                  </div>
              }
              {this.state.changePassword === false ? login : <ForgotPasswordForm />}
              <p />
            </Card>
          </div>
        )}
      </div>
    );
  }

  private setLoading(e: any | boolean) {
    this.props.dispatch(
      UserDucks.setLoading(e === true || e === false ? e : true)
    );
  }

}

const mapStateToProps = state => {
  return {
    isLoading: UserDucks.isLoading(state),
    isLoggedIn: UserDucks.isAuthenticated(state)
  };
};

const x = withCookies(LoginForm)
export default connect(mapStateToProps)(x);



// WEBPACK FOOTER //
// ./src/pages/auth/login/components/login-form/LoginForm.tsx